import { AxiosResponse } from 'axios'
import { captureException } from '@/controller/sentryHelper.ts'
import { saveAs } from '@/controller/fileSaver.ts'

export async function updateHelper<T extends (...args: any) => Promise<AxiosResponse>>(
  isLoading: boolean,
  setLoading: (loading: boolean) => void,
  updater: T,
  exceptionSrc: string,
  errorMsg: string,
  resData: (resData: any) => Promise<void>,
  ...data: Parameters<T>
) {
  if (isLoading) {
    return
  }

  try {
    setLoading(true)
    const res = await updater(...data)
    if (resData) {
      await resData(res.data)
    }
  } catch (e) {
    captureException(e, exceptionSrc, () => data)
    alert(`${errorMsg}: ` + JSON.stringify(e))
  }
  setLoading(false)
}

export async function shareDownloadedFileByUrl(url: string, fileName: string, setIsDownloading: (downloading: boolean) => void) {
  setIsDownloading(true)
  const blob = await fetch(url, {
    cache: 'no-store',
  }).then(res=> res.blob())
  setIsDownloading(false)
  return await navigator.share({
    files: [new File([blob], fileName, { type: blob.type, })],
  })
}

export async function shareDownloadURL(url: string, fileName: string, setIsDownloading: (downloading: boolean) => void, alternateDownloadLink: string | undefined=undefined) {
  const iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
  if (iOS && navigator.share != null) {
    return shareDownloadedFileByUrl(url, fileName, setIsDownloading)
  }

  return saveAs(alternateDownloadLink || url, fileName, setIsDownloading)
}
